import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  ADMIN_SCAN_PAY,
  USER_WALLET_TRANSACTIONS_MAIN,
  USER_WALLET_TRANSACTIONS,
  GET_ALL_DONATIONS,
  GET_ALL_DONATIONS_REPORT,
  GET_ALL_VENDOR_SETTLEMENT,
  GET_PAYMENT_HISTORY,
  GET_ALL_VENDOR_STATEMENT,
  SINGLE_VENDOR_STATEMENT
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";
import { amApi } from "../../../api/apiHelper";

export const adminScanPay = (token, query) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let get_scan_pay = await axios.get(
      `${serverApi}/admin/transactional`,
      { params: query },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_scan_pay.status === 200) {
      dispatch({ type: ADMIN_SCAN_PAY, payload: get_scan_pay.data });
      dispatch({ type: CLEAR_LOADER });
    } else {
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_User_Wallet_Transactions_Main =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let userWalletTransactionsMain = await axios.get(
        `${serverApi}/payment/wallet?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (userWalletTransactionsMain.status === 200) {
        dispatch({
          type: USER_WALLET_TRANSACTIONS_MAIN,
          payload: userWalletTransactionsMain.data,
        });
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const userWalletTransactions = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let userWalletTransactions = await axios.get(
      `${serverApi}/admin/withdraw-request`,

      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (userWalletTransactions.status === 200) {
      dispatch({
        type: USER_WALLET_TRANSACTIONS,
        payload: userWalletTransactions.data,
      });
      dispatch({ type: CLEAR_LOADER });
    } else {
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_Update_User_Wallet_Transactions =
  (token, id, formData, onSucess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let userWalletTransactions = await axios.patch(
        `${serverApi}/admin/withdraw-request/${id}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (userWalletTransactions.status === 200) {
        Alert.success(`<h4>Status updated sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSucess();
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_all_donations = (token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let get_all_donations = await axios.get(
      `${serverApi}/donation`,

      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_all_donations.status === 200) {
      dispatch({
        type: GET_ALL_DONATIONS,
        payload: get_all_donations.data,
      });
      onSuccess();
      dispatch({ type: CLEAR_LOADER });
    } else {
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_all_organizations =
  (token, onSuccessLoadOrganizations) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_all_organizations = await axios.get(
        `${serverApi}/organization`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_all_organizations.status === 200) {
        onSuccessLoadOrganizations(get_all_organizations.data);

        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const donate_now_to_organization =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let donate_now_to_organization = await axios.post(
        `${serverApi}/donationsettlement`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (donate_now_to_organization.status === 201) {
        onSuccess();

        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_donation_report = (token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let donate_now_to_organization = await axios.get(
      `${serverApi}/donationsettlement`,

      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (donate_now_to_organization.status === 200) {
      onSuccess();
      dispatch({
        type: GET_ALL_DONATIONS_REPORT,
        payload: donate_now_to_organization.data,
      });
      dispatch({ type: CLEAR_LOADER });
    } else {
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_referal_donations = (token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let get_referal_donations = await axios.get(
      `${serverApi}/invite-friend?referral_qualified=true`,

      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_referal_donations.status === 200) {
      dispatch({
        type: GET_ALL_DONATIONS,
        payload: get_referal_donations.data,
      });
      onSuccess();
      dispatch({ type: CLEAR_LOADER });
    } else {
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_organization_details_by_id =
  (token, organizationId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_organization_details_by_id = await axios.get(
        `${serverApi}/organization/${organizationId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_organization_details_by_id.status === 200) {
        onSuccess(get_organization_details_by_id.data);
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_settlement_amount =
  (token, settlementId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_settlement_amount = await axios.get(
        `${serverApi}/donationsettlement/${settlementId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_settlement_amount.status === 200) {
        onSuccess(get_settlement_amount.data);
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_donations_user_details =
  (token, organizationId, settlementId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_settlement_amount = await axios.get(
        `${serverApi}/donation?organization_id=${organizationId}&donation_settlement_id=${settlementId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_settlement_amount.status === 200) {
        onSuccess(get_settlement_amount.data);
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_donations_user_details_referal =
  (token, organizationId, settlementId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_donations_user_details_referal = await axios.get(
        `${serverApi}/invite-friend??organization_id=${organizationId}&donation_settlement_id=${settlementId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_donations_user_details_referal.status === 200) {
        onSuccess(get_donations_user_details_referal.data);
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_vendor_settlement =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_vendor_settlement = await axios.get(
        `${serverApi}/settlement?status=CURRENT&startDate=${startDate}&endDate=${endDate}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_vendor_settlement.status === 200) {
        onSuccess(get_vendor_settlement.data);
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_ALL_VENDOR_SETTLEMENT,
          payload: get_vendor_settlement.data,
        });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_vendor_statement =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendor_settlement = await axios.get(
        `${serverApi}/merchantStatement?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_vendor_settlement.status === 200) {
        onSuccess(get_vendor_settlement.data);
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_ALL_VENDOR_STATEMENT,
          payload: get_vendor_settlement.data,
        });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };


export const get_merchant_statement =
  (token, id, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendor_settlement = await axios.get(
        `${serverApi}/merchantStatement/${id}?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          }
        }
      );
      if (get_vendor_settlement.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SINGLE_VENDOR_STATEMENT,
          payload: get_vendor_settlement.data[0],
        });
        onSuccess(get_vendor_settlement.data);
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_subscription_details =
  (token, vendorId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_subscription_details = await axios.get(
        `${serverApi}/admin/subscription/${vendorId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_subscription_details.status === 200) {
        onSuccess(get_subscription_details.data);
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const requestSettlementProcess =
  (formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_subscription_details = await amApi.post(`/settlement_record`, formData);
      if (get_subscription_details.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_payout_vendor =
  (token, formData, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_subscription_details = await axios.post(
        `${serverApi}/settlement`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_subscription_details.status === 404) {
        onError("Incorrect Bank details.");
      } else {
        if (get_subscription_details.data) {
          Alert.success(`<h4>Payout was Sucessfully completed</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          onSuccess(formData.payout_type);
        } else {
          dispatch({ type: CLEAR_LOADER });
        }
      }
    } catch (err) {
      onError(
        err && err.response && err.response.data && err.response.data.message
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_payment_history =
  (token, vendorId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_payment_history = await axios.get(
        `${serverApi}/settlement?status=HISTORY&vendor_id=${vendorId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_payment_history.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_PAYMENT_HISTORY,
          payload: get_payment_history.data,
        });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
